module.exports = __webpack_public_path__ + "img/treatments-directory-dashboard-desktop-fr.4d0b4be5.jpg";